export default __webpack_public_path__ + "static/media/ploylight.163075a8.png";